import Vue from "vue";
import func from "./func";

Vue.filter("substr", (str, from, len) => {
    return str.substr(from, len);
});

Vue.filter("tsFormat", func.tsFormat);

Vue.filter("GB", func.bytes2GB);
Vue.filter("bytes", func.bytesAuto);
Vue.filter("formatCNY", func.formatCNY);
Vue.filter("formatCNF", func.formatCNF);
